import React, { Component, useState } from 'react';

import CarouselImageCard from '../../cards/carouselImageCard';
import { useDispatch } from 'react-redux';

interface CarouselProps {
  items: any[];
  setSelectedImageID: React.Dispatch<any>;
  selectedImageID: string;
}

const Carousel: React.FC<CarouselProps> = ({
  items,

  selectedImageID,
  setSelectedImageID
}) => {
  const dispatch = useDispatch();

  return (
    <div className="w-100 d-flex flex-column justify-content-center align-items-start gap-2 mx-auto">
      {items.map((item, index) => {
        return (
          <div
            onClick={() => {
              setSelectedImageID(item?.uuid);
            }}
            key={`imageCard-${item?.id}`}
            className="mx-auto"
          >
            <div className={`cursor-pointer`}>
              <CarouselImageCard
                active={selectedImageID === item.uuid ? true : false}
                image={
                  item.preview_image ? item.preview_image : item.thumbnail_image
                }
                item={item}
                key={item.id}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Carousel;
